import ParticipantServiceFamily, {IParticipantServiceFamily} from "@/model/ServiceFamily/ParticipantServiceFamily"

export interface ISkipassServiceFamily extends IParticipantServiceFamily {
    
}

class SkipassServiceFamily extends ParticipantServiceFamily implements ISkipassServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}

export default SkipassServiceFamily